export default __webpack_public_path__ + "static/media/android-white.983244cf.svg";